<template>
    <el-dialog
            title="属性选择"
            :visible.sync="shuxingDialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            width="600px"
            center>
        <el-form :model="accountForm" :rules="rules" ref="accountForm" label-width="100px">
            <el-form-item label="属性分类" prop="name">
                <el-select v-model="accountForm.id" filterable placeholder="请选择属性分类" style="width: 100%">
                    <el-option
                            v-for="item in types"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item class="flex align-center justify-around" label-width="0">
                <el-button class="padding-lr-xl" @click="resetForm('accountForm')">取消</el-button>
                <el-button class="padding-lr-xl" type="primary" @click="submitForm('accountForm')">提交</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>

import {updateWatchPeopleDetail7} from "@/api/service";
import {jvminShuxingList} from "@/utils/utils";

export default {
    name: "shuxingDialog",
    props: {
        shuxingDialog: {
            type: Boolean,
            default: false
        },
        s_id:{
            type: Number ,
            default: 0
        }
    },
    data() {

        return {
            types:jvminShuxingList,
            accountForm: {
                id: '',

            },
            rules: {
                id: [{required: true, message: '请选择属性分类', trigger: 'change'}],
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },

    },
    created() {

    },
    methods: {

        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$emit('cancelDialog', false)
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _state = await updateWatchPeopleDetail7(
                this.$route.params.id,
                this.accountForm.id,
            );
            this.$message.success(_state.info);
            this.$refs[formName].resetFields();
            this.$emit("cancelDialog", true);
        }

    },
    watch: {
        s_id() {
            this.accountForm = {
                id: this.s_id?this.s_id:'',
            };
        },
    }
}
</script>

<style scoped lang="scss">

</style>
